<template>
	<div>
		<!-- <h2>Ejemplares</h2> -->
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: "InventoryChicksMain",
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss"></style>
